export enum AssetTypeEnum {
    PPE = 0,
    TenantLogo = 1,
    DeviceCalibrationHistory = 2,
    MapResult = 3,
    ZoneResult = 4,
    Report = 5,
    Note = 6,
    SensorVideo = 7,
    CustomMap = 8,
    SensorAssignmentImage = 9,
    IHAttachments = 10,
}